module.exports = __webpack_public_path__ + "media/8.f8ec1dfc.mp3";